/* eslint-disable @typescript-eslint/ban-ts-comment */
import { TooltipProps, TypographyProps } from "@material-ui/core";
import { Variant } from "@material-ui/core/styles/createTypography";
import { useEffect, useState } from "react";
import LyfeTooltip from "../LyfeTooltip/LyfeTooltip";
import Typography, { LyfeTypographyTypes } from "../Typography/Typography";
import getTextWidth from "../utils/getTextWidth";

export interface IFlexTypographyProps {
	text: string;
	variant?: Variant | "inherit";
	type?: LyfeTypographyTypes["type"];
	renderText?: (text: string) => string;
	renderTooltipText?: (text: string) => string;
	typographyProps?: TypographyProps;
	tooltipPlacement?: TooltipProps["placement"];
	width: number;
	forceTooltipRender?: boolean;
	forceHideTooltip?: boolean;
	itemCounter?: string;
	flexAlignment?: string;
}

export const FlexTypography: React.FC<IFlexTypographyProps> = (props) => {
	const [hideTooltip, setHideTooltip] = useState(false);
	const defaultTypographyProps: TypographyProps & LyfeTypographyTypes = {
		noWrap: true,
		variant: props.variant ?? "body2",
		type: props.type ?? "regular",
		...props.typographyProps,
	};

	useEffect(() => {
		const textW = getTextWidth(props.text);
		if (props.width > textW) {
			setHideTooltip(true);
		} else {
			setHideTooltip(false);
		}
	}, [props.width, props.text]);

	return (
		<>
			{((hideTooltip && !props.forceTooltipRender) || props.forceHideTooltip) && (
				<div style={{ display: "flex", justifyContent: props.flexAlignment }}>
					<span style={{ overflow: !hideTooltip ? "hidden" : "visible" }}>
						<Typography display="block" {...defaultTypographyProps}>
							{props.renderText ? props.renderText(props.text) : props.text}
						</Typography>
					</span>
				</div>
			)}
			{(!hideTooltip || props.forceTooltipRender) && !props.forceHideTooltip && (
				<LyfeTooltip
					title={props.renderTooltipText ? props.renderTooltipText(props.text) : props.text}
					placement={props.tooltipPlacement}
				>
					<div style={{ display: "flex", justifyContent: props.flexAlignment, alignItems: "center" }}>
						<div style={{ overflow: !hideTooltip ? "hidden" : "visible" }}>
							<Typography type="status" display="block" {...defaultTypographyProps}>
								{props.renderText ? props.renderText(props.text) : props.text}
							</Typography>
						</div>
						<Typography {...defaultTypographyProps} variant={props.variant}>
							{props.itemCounter}
						</Typography>
					</div>
				</LyfeTooltip>
			)}
		</>
	);
};
